import { Layout, Menu } from 'antd';
import { getMenuItems } from '../../routes/menuItems';

const { Sider } = Layout;

const Sidebar = ({ collapsed, onCollapse }) => {
  return (
    <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
      <div className="demo-logo-vertical" />
      <Menu
        theme="dark"
        defaultSelectedKeys={['1']}
        mode="inline"
        items={getMenuItems()}
      />
    </Sider>
  );
};

export default Sidebar;